<template>
  <ul class="options-list">
    <li
      class="options-list__item"
      ref="option"
      v-for="(option, idx) in options"
      :key="option.text"
    >

      <Mediator
        class="options-list__marker"
        :type="answered ? option.correct ? 'success' : 'failed' : 'normal'"
      >
      </Mediator>

      <div
        class="options-list__text text"
        :disabled="answered"
        :class="option.checked ? option.correct ? 'correct' : 'failed' : ''"
        @click="input(idx)"
        v-html="option.text"
      ></div>

      <collapse :duration="collapseDuration" :open="answered && checkedValue === idx">
        <div
          class="options-list__explain subtext"
          v-html="option.explain"
        >
        </div>
      </collapse>

    </li>
  </ul>
</template>

<script>
  import Mediator from '@/components/Mediator.vue'
  import Collapse from '@/components/Collapse.vue'
  import anime from 'animejs'

  export default {
    components: { Collapse, Mediator },
    data () {
      return { collapseDuration: 350 }
    },
    computed: {
      options () {
        return this.$store.getters.question.options.map((option, idx) => {
          const correct = this.correctValue === idx
          const checked = this.checkedValue === idx
          return { ...option, checked, correct }
        })
      },
      answered () {
        return this.$store.getters.answered
      },
      correct () {
        return this.$store.getters.correct
      },
      correctValue () {
        return this.$store.getters.question.correct
      },
      checkedValue () {
        return this.answered ? this.$store.state.score[this.$store.state.current].value : null
      }
    },
    methods: {
      input (idx) {
        this.$store.dispatch('answer', Number(idx))
        setTimeout(() => this.scrollTo(idx), this.collapseDuration)
      },
      scrollTo (idx) {
        const el = this.$refs.option[idx]
        const targetOffset = el.offsetTop
        const page = document.querySelector('.page')
        const bottomEdge = targetOffset + window.innerHeight
        const offset = bottomEdge > page.scrollHeight ? page.scrollHeight - window.innerHeight : targetOffset
        anime({
          targets: page,
          easing: 'easeInOutQuad',
          scrollTop: offset,
          duration: 500,
        })
      }
    }
  }
</script>

<style lang="scss">
  .options-list {

  }
  .options-list__item {
    position: relative;
    margin-bottom: 0;
    padding-left: 32px;
    transition: 1s opacity, 1s transform;
    transition-delay: 3.5s;
    @include less(tablet) {
      &:last-child {
        padding-bottom: 40px;
      }
    }
  }

  .options-list__marker {
    position: absolute;
    top: 14px;
    left: 0;
    font-size: 14px;
    color: $color-cyan;
    flex: 0 0 auto;
    margin-right: 16px;
  }

  .options-list__text {
    padding: 10px 10px 10px 0;
    cursor: pointer;
    &[disabled] {
      pointer-events: none;
    }

    &:hover {
      background: linear-gradient(to left, rgba($color-cyan, 0.45), rgba($color-cyan, 0));
    }
    &.failed {
      background: linear-gradient(to left, rgba($color-red, 0.4), rgba($color-red, 0));
    }
    &.correct {
      background: linear-gradient(to left, rgba($color-green, 0.5), rgba($color-green, 0));
    }
  }

  .options-list__explain {
    margin-bottom: 20px;
  }


  @for $i from 1 through 7 {
    .options-list__item:nth-child(#{$i}) {
      $delay: 0.1s + $i * 0.2s;
      transition-delay: $delay;
    }
  }

  @include more(scale) {
    .quiz-enter-active {
      .options-list__item {
        opacity: 0;
        transform: translateX(20px);
      }
    }
    .quiz-enter-to {
      .options-list__item {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }
</style>
